import React, {Component} from 'react';
import {__} from "i18n-for-browser";

export default class HideDesktopMobileContents extends Component {
  render() {
    const desktop = document.querySelector('#root').clientWidth >= 1240;

    return (
      <div className={( desktop ? 'desktop' : 'mobiele') + '-notification refresh-page'}>
        <p>{__('sim_' + ( desktop ? 'mobile' : 'desktop') + '_view_notification')}</p>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/elements/HideDesktopMobileContents.js